import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Subject} from 'rxjs';
import * as DashboardActions from '../store/dashboard.action';
import * as DashboardSelectors from '../store/dashboard.selectors';

@Injectable({
    providedIn: 'root'
})

export class DashboardFacade {

    public lastSignedDocuments$ = this._store$.select(DashboardSelectors.lastSignedDocuments);
    public bouncedDocuments$ = this._store$.select(DashboardSelectors.bouncedDocuments);
    public expireContracts$ = this._store$.select(DashboardSelectors.aboutToExpireContracts);
    public mostActiveUsers$ = this._store$.select(DashboardSelectors.mostActiveUsers);
    public dashboardSettings$ = this._store$.select(DashboardSelectors.dashboardSettings);
    public latestActivity$ = this._store$.select(DashboardSelectors.latestActivities);
    public mostUsedTemplates$ = this._store$.select(DashboardSelectors.mostUsedTemplates);
    public aboutToExpire$ = this._store$.select(DashboardSelectors.aboutToExpire);
    public unreadChatMessages$ = this._store$.select(DashboardSelectors.unreadChatMessages);
    public forgottenDocuments$ = this._store$.select(DashboardSelectors.forgottenDocuments);
    public autoRenewalOn$ = this._store$.select(DashboardSelectors.autoRenewalOn);
    public taskAndReminderSettings$ = this._store$.select(DashboardSelectors.taskAndReminderSettings);
    public refreshMurriWidgets = new Subject<{ refresh: number }>();

    constructor (private _store$: Store) {}


    fetchDashboardSettings(){
        this._store$.dispatch(DashboardActions.fetchDashboardSettings());
    }


    updateDashboardSetting(key: string, value: string){
        this._store$.dispatch(DashboardActions.updateDashboardSetting(key, value));
    }


    fetchLastSignedDocuments(){
        this._store$.dispatch(DashboardActions.fetchLastSignedDocuments());
    }


    fetchBouncedDocuments(){
        this._store$.dispatch(DashboardActions.fetchEmailBouncedDocuments());
    }


    fetchExpireContracts() {
        this._store$.dispatch(DashboardActions.fetchExpireContracts());
    }

    fetchMostActiveUsers (){
        this._store$.dispatch(DashboardActions.mostActiveUsers())
    }

    fetchLatestActivity(){
        this._store$.dispatch(DashboardActions.fetchLatestActivity());
    }

    fetchMostUsedTemplates(){
        this._store$.dispatch(DashboardActions.fetchMostUsedTemplates());
    }

    fetchAboutToExpire(){
        this._store$.dispatch(DashboardActions.fetchAboutToExpire());
    }

    fetchUnreadChatMessages(){
        this._store$.dispatch(DashboardActions.fetchUnreadChatMessages());
    }

    fetchForgottenDocuments(){
        this._store$.dispatch(DashboardActions.fetchForgottenDocuments());
    }

    fetchAutoRenewalOn(){
        this._store$.dispatch(DashboardActions.fetchAutoRenewalOn());
    }

    fetchTaskAndReminderSettings(){
        this._store$.dispatch(DashboardActions.fetchTaskAndReminders());
    }
}
